"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var RecurringBillingScheduleSubjectTypeEnum;
(function (RecurringBillingScheduleSubjectTypeEnum) {
    RecurringBillingScheduleSubjectTypeEnum["SUBSCRIPTION"] = "subscription";
})(RecurringBillingScheduleSubjectTypeEnum = exports.RecurringBillingScheduleSubjectTypeEnum || (exports.RecurringBillingScheduleSubjectTypeEnum = {}));
class RecurringBillingScheduleProvider extends DataProvider_1.default {
    get fragments() {
        return {
            RecurringBillingSchedule: () => `
        ... on RecurringBillingSchedule {
          id
          userId
          paymentSystemId
          pricePackageId
          cancelled
          createTime
          lastBillingTime
          schedule {
            ${this.getFragment("RecurringSchedule")}
          }
          contentSubject {
            ${this.getFragment("Subject")}
          }
          cost {
            ${this.getFragment("CurrencyCost")}            
          }
        }
      `,
            RecurringSchedule: () => `
        ... on RecurringSchedule {
          nextBillingTime
          interval
        }
      `,
            RecurringBillingScheduleContent: () => `
        ... on EmptyRecurringBillingScheduleContent {
          _
        }
      `,
            Subject: () => `
        subjectId
        subjectType
      `,
        };
    }
    search({ data }, fields) {
        return this.query("recurringBillingScheduleSearch", { data }, this.getPageableFragment("RecurringBillingSchedule", fields));
    }
    cancel({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("recurringBillingScheduleCancel", { data });
        });
    }
}
exports.RecurringBillingScheduleProvider = RecurringBillingScheduleProvider;
//# sourceMappingURL=RecurringBillingScheduleProvider.js.map